import React, { Component } from "react";
import LabelDropDownInput from "../../Inputs/LabelDropDownInput";

const LIMIT_OPTIONS = [
  { name: "Select Claim Limit", value: "" },
  { name: "Limited", value: "limited" },
  { name: "Unlimited", value: "unlimited" },
];

const FREQUENCY_OPTIONS = [
  { name: "Select Limit", value: "" },
  { name: "Once a day", value: "once_a_day" },
  { name: "Once a week", value: "once_a_week" },
  { name: "Once a month", value: "once_a_month" },
  { name: "Once Campaign", value: "once_campaign" },
];

export default class CouponRedemptionLimit_View extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: props.limitType || "",
      freq: props.frequency || "",
    };
  }

  componentDidMount() {
    if (this.props.onChange) {
      this.props.onChange({
        limitType: this.state.limit,
        frequency: this.state.freq,
      });
    }
  }

  componentDidUpdate(prevProps) {
    // sync internal state if parent passes updated values (e.g., on edit prefill)
    if (
      prevProps.limitType !== this.props.limitType ||
      prevProps.frequency !== this.props.frequency
    ) {
      this.setState(
        {
          limit: this.props.limitType || "",
          freq: this.props.frequency || "",
        },
        () => {
          if (this.props.onChange)
            this.props.onChange({
              limitType: this.state.limit,
              frequency: this.state.freq,
            });
        }
      );
    }
  }

  handleLimitChange = (e) => {
    const value = e.target.value;
    const newState = { limit: value };
    if (value !== "limited") newState.freq = "";
    this.setState(newState, () => {
      if (this.props.setRedemptionLimit)
        this.props.setRedemptionLimit({
          limitType: this.state.limit,
          frequency: this.state.freq,
        });
      if (this.props.onChange)
        this.props.onChange({
          limitType: this.state.limit,
          frequency: this.state.limit === "limited" ? this.state.freq : "",
        });
    });
  };

  handleFreqChange = (e) => {
    const value = e.target.value;
    this.setState({ freq: value }, () => {
      if (this.props.setRedemptionLimit)
        this.props.setRedemptionLimit({
          limitType: this.state.limit,
          frequency: this.state.freq,
        });
      if (this.props.onChange)
        this.props.onChange({
          limitType: this.state.limit,
          frequency: this.state.freq,
        });
    });
  };

  render() {
    const { limit, freq } = this.state;
    // receive flags/error messages from parent (ManageCouponInventory passes them)
    const limitFlag = this.props.limitFlag || false;
    const limitErrorMsg = this.props.limitErrorMsg || "Field Required";
    const freqFlag = this.props.frequencyFlag || false;
    const freqErrorMsg = this.props.frequencyErrorMsg || "Field Required";

    return (
      <div className="ov-feild date-over">
        <LabelDropDownInput
          data={LIMIT_OPTIONS}
          label="Claim Limit"
          type="claimLimit"
          name="claimLimit"
          star="*"
          id="claimLimit"
          inputValue={limit}
          onChange={this.handleLimitChange}
          flag={limitFlag}
          errorMsg={limitErrorMsg}
        />
        {limit === "limited" && (
          <div style={{ marginTop: 8 }}>
            <LabelDropDownInput
              data={FREQUENCY_OPTIONS}
              label="Limit Frequency"
              type="claimFrequency"
              name="claimFrequency"
              star="*"
              id="claimFrequency"
              inputValue={freq}
              onChange={this.handleFreqChange}
              flag={freqFlag}
              errorMsg={freqErrorMsg}
            />
          </div>
        )}
      </div>
    );
  }
}